module.exports = __webpack_public_path__ + "img/Weapon_279.e24cfc6a.png";